module.exports = __webpack_public_path__ + "img/solar-panel.ba5714ff.png";